module.exports = __webpack_public_path__ + "static/media/truck-blue.2a340ce8.svg";